module.exports = "/assets/data/dad07ffc1c49789ada23fdb2fb8baedc-S60.data.json";